<template>
    <div class="container text">
        Platební bránu poskytuje firma <a href="https://www.comgate.cz/cz/platebni-brana">Comgate, a.s</a>. Platit je možné pomocí <a href="https://help.comgate.cz/v1/docs/cs/platby-kartou">platební karty</a> nebo <a href="https://help.comgate.cz/docs/bankovni-prevody">bankovním převodem</a>. Podrobnosti a přesný postup platby včetně animací najdete v odkazech.<br />
        Kontakt na Comgate, a.s.<br />
        Gočárova třída 1754 / 48b, Hradec Králové<br />
        E-mail: platby-podpora@comgate.cz<br />
        Tel: +420 228 224 267<br />
    </div>
</template>